import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import GoldenParticles from "@/components/GoldenParticles";
import { useLang } from "@/context/LanguageContext";
import { track } from "@/lib/api";

const STEPS = [
  "analysis.1", "analysis.2", "analysis.3", "analysis.4", "analysis.5",
];

export default function AnalysisPage() {
  const { lang, t } = useLang();
  const { leadId } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(0);

  useEffect(() => {
    track("analysis_start", { lead_id: leadId });
    let i = 0;
    const iv = setInterval(() => {
      i++;
      if (i >= STEPS.length) {
        clearInterval(iv);
        track("analysis_complete", { lead_id: leadId });
        setTimeout(() => navigate(`/${lang}/reveal/${leadId}`), 900);
      } else setStep(i);
    }, 1100);
    return () => clearInterval(iv);
  }, [leadId, lang, navigate]);

  return (
    <div data-testid="analysis-animation-container" className="fixed inset-0 bg-obsidian flex items-center justify-center overflow-hidden">
      <GoldenParticles density={140} />
      <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(214,170,69,0.08)_0%,transparent_70%)]" />
      <div className="relative text-center px-6 max-w-lg">
        <div className="w-24 h-24 mx-auto mb-10 relative">
          <div className="absolute inset-0 rounded-full border border-gold-active animate-gold-pulse" />
          <div className="absolute inset-3 rounded-full border border-gold" />
          <div className="absolute inset-6 rounded-full border border-gold/50" />
          <div className="absolute inset-0 flex items-center justify-center font-serif-lux text-3xl text-gold-hi">ॐ</div>
        </div>
        <div className="min-h-[3.5rem] flex items-center justify-center">
          <p key={step} className="font-serif-lux text-xl sm:text-2xl text-gold-hi animate-fade-up">
            {t(STEPS[step])}
          </p>
        </div>
        <div className="mt-12 h-1 bg-card-warm rounded-full overflow-hidden max-w-xs mx-auto">
          <div className="h-full bg-gradient-to-r from-[#D6AA45] via-[#F2D27A] to-[#FFBF47] transition-all duration-700" style={{ width: `${((step + 1) / STEPS.length) * 100}%` }} />
        </div>
      </div>
    </div>
  );
}
